import uiEn from "./ui.en.json";
import uiFr from "./ui.fr.json";
import commonEn from "./common.en.json";
import commonFr from "./common.fr.json";
import listsEn from "./lists.en.json";
import listsFr from "./lists.fr.json";
import coreEn from "./core.en.json";
import coreFr from "./core.fr.json";
import accessEn from "./access.en.json";
import accessFr from "./access.fr.json";
import documentsEn from "./documents.en.json";
import documentsFr from "./documents.fr.json";
import tasksEn from "./tasks.en.json";
import tasksFr from "./tasks.fr.json";
import blockPagesEn from "./block_pages.en.json";
import blockPagesFr from "./block_pages.fr.json";
import emailMarketingEn from "./email_marketing.en.json";
import emailMarketingFr from "./email_marketing.fr.json";
import opportunityTrackingEn from "./opportunity_tracking.en.json";
import opportunityTrackingFr from "./opportunity_tracking.fr.json";
import commentsEn from "./comments.en.json";
import commentsFr from "./comments.fr.json";
import tagManagementEn from "./tag_management.en.json";
import tagManagementFr from "./tag_management.fr.json";
import progressTrackerEn from "./progress_tracker.en.json";
import progressTrackerFr from "./progress_tracker.fr.json";
import contactsReviewEn from "./contacts_review.en.json";
import contactsReviewFr from "./contacts_review.fr.json";
import customObjectsEn from "./custom_objects.en.json";
import customObjectsFr from "./custom_objects.fr.json";
import formBuilderEn from "./form_builder.en.json";
import formBuilderFr from "./form_builder.fr.json";
import importsEn from "./imports.en.json";
import importsFr from "./imports.fr.json";
import industryMapperEn from "./industry_mapper.en.json";
import industryMapperFr from "./industry_mapper.fr.json";
import listReminderEn from "./list_reminder.en.json";
import listReminderFr from "./list_reminder.fr.json";
import myEn from "./my.en.json";
import myFr from "./my.fr.json";
import myCalendarEn from "./my_calendar.en.json";
import myCalendarFr from "./my_calendar.fr.json";
import referralTrackingEn from "./referral_tracking.en.json";
import referralTrackingFr from "./referral_tracking.fr.json";
import navAndLayoutEn from "./nav_and_layout.en.json";
import navAndLayoutFr from "./nav_and_layout.fr.json";
import notesEn from "./notes.en.json";
import notesFr from "./notes.fr.json";
import tableLikeEn from "./table_like.en.json";
import tableLikeFr from "./table_like.fr.json";
import userInterfaceEn from "./user_interface.en.json";
import userInterfaceFr from "./user_interface.fr.json";
import nexlAiEn from "./nexl_ai.en.json";
import nexlAiFr from "./nexl_ai.fr.json";
import enrichmentEn from "./enrichment.en.json";
import enrichmentFr from "./enrichment.fr.json";
import auditTrailEn from "./audit_trail.en.json";
import auditTrailFr from "./audit_trail.fr.json";
import customFieldEn from "./custom_field.en.json";
import customFieldFr from "./custom_field.fr.json";

export const namespaces: string[] = [
  "ui",
  "common",
  "lists",
  "core",
  "access",
  "documents",
  "tasks",
  "block_pages",
  "email_marketing",
  "opportunity_tracking",
  "comments",
  "tag_management",
  "progress_tracker",
  "table_like",
  "contacts_review",
  "custom_objects",
  "form_builder",
  "imports",
  "industry_mapper",
  "list_reminder",
  "my",
  "my_calendar",
  "referral_tracking",
  "nav_and_layout",
  "notes",
  "user_interface",
  "nexl_ai",
  "enrichment",
  "audit_trail",
  "custom_field",
];

export const resources: { en: Record<string, any>; fr: Record<string, any> } = {
  en: {
    ui: uiEn,
    common: commonEn,
    lists: listsEn,
    core: coreEn,
    access: accessEn,
    documents: documentsEn,
    tasks: tasksEn,
    block_pages: blockPagesEn,
    email_marketing: emailMarketingEn,
    opportunity_tracking: opportunityTrackingEn,
    comments: commentsEn,
    tag_management: tagManagementEn,
    progress_tracker: progressTrackerEn,
    table_like: tableLikeEn,
    contacts_review: contactsReviewEn,
    custom_objects: customObjectsEn,
    form_builder: formBuilderEn,
    imports: importsEn,
    industry_mapper: industryMapperEn,
    list_reminder: listReminderEn,
    my: myEn,
    my_calendar: myCalendarEn,
    referral_tracking: referralTrackingEn,
    nav_and_layout: navAndLayoutEn,
    notes: notesEn,
    user_interface: userInterfaceEn,
    nexl_ai: nexlAiEn,
    enrichment: enrichmentEn,
    audit_trail: auditTrailEn,
    custom_field: customFieldEn,
  },
  fr: {
    ui: uiFr,
    common: commonFr,
    lists: listsFr,
    core: coreFr,
    access: accessFr,
    documents: documentsFr,
    tasks: tasksFr,
    block_pages: blockPagesFr,
    email_marketing: emailMarketingFr,
    opportunity_tracking: opportunityTrackingFr,
    comments: commentsFr,
    tag_management: tagManagementFr,
    progress_tracker: progressTrackerFr,
    table_like: tableLikeFr,
    contacts_review: contactsReviewFr,
    custom_objects: customObjectsFr,
    form_builder: formBuilderFr,
    imports: importsFr,
    industry_mapper: industryMapperFr,
    list_reminder: listReminderFr,
    my: myFr,
    my_calendar: myCalendarFr,
    referral_tracking: referralTrackingFr,
    nav_and_layout: navAndLayoutFr,
    notes: notesFr,
    user_interface: userInterfaceFr,
    nexl_ai: nexlAiFr,
    enrichment: enrichmentFr,
    audit_trail: auditTrailFr,
    custom_field: customFieldFr,
  },
};
